import { Store } from '@/model/types'
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'

const PADDING = 10
const TWICE_PADDING = PADDING * 2
const WIDTH = 200 // Keep width and height in sync with CSS
const HEIGHT = 120

@Component
export default class Minimap extends Vue {
  @Prop() store!: Store;

  @Ref('root') readonly root: SVGElement | undefined;

  // Similar exists in ProjectEditor.
  private get maxOffsets () {
    const xValues = Object.values(this.store.project.tasks).map(t => t.x)
    const yValues = Object.values(this.store.project.tasks).map(t => t.y)

    const max = (v: number[]) => v.reduce((a, b) => Math.max(a, b), 0)
    const min = (v: number[]) => v.reduce((a, b) => Math.min(a, b), 0)

    return {
      minX: min(xValues),
      maxX: max(xValues),
      minY: min(yValues),
      maxY: max(yValues)
    }
  }

  private get cameraBounds () {
    const width = this.store.camera.width / this.store.camera.zoom
    const height = this.store.camera.height / this.store.camera.zoom
    return {
      x: -this.store.camera.xOff - width / 2,
      y: this.store.camera.yOff - height / 2,
      width,
      height
    }
  }

  private get transform () {
    const o = this.maxOffsets
    // Or with 1 in case the span is zero
    const xSpan = (o.maxX - o.minX) || 1
    const ySpan = (o.maxY - o.minY) || 1
    const width = Math.max(WIDTH - TWICE_PADDING, 1)
    const height = Math.max(HEIGHT - TWICE_PADDING, 1)
    const scale = Math.min(width / xSpan, height / ySpan)
    const xCenter = (o.minX + o.maxX) / 2
    const yCenter = (o.minY + o.maxY) / 2
    return {
      scale,
      svg: `
        translate(${width / 2 + PADDING}, ${height / 2 + PADDING})
        scale(${scale}, ${-scale})
        translate(${-xCenter}, ${-yCenter})
      `
    }
  }
}
